<template>
  <div>
    <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
      <a-divider orientation="left">
        <b>{{ formTitle }}</b>
      </a-divider>
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="推送类型" prop="type">
          <a-select style="width: 250px" v-model="form.type" placeholder="请选择类型" @change="changeType">
            <a-select-option v-for="(item, index) in this.customDict.PushNoticeTypeEnum" :value="item.type" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="跳转类型" prop="jumpType">
          <a-select style="width: 250px" v-model="form.jumpType" placeholder="请选择跳转类型" @change="changeJumpType">
            <a-select-option v-for="(item, index) in this.customDict.PushNoticeJumpTypeEnum" :value="item.type" :key="index" v-if="index < 9">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label="typeLabels[form.jumpType]"
          prop="relationId"
          v-if="form.jumpType && form.jumpType !== '0'"
        >
          <a-button type="dashed" @click="jumpFunction()" danger>
            <span style="color: dodgerblue"> {{ form.remark }}</span>
          </a-button>
        </a-form-model-item>
        <!--      <a-form-model-item label="关联id" prop="relationId" >-->
        <!--        <a-input v-model="form.relationId" placeholder="请输入关联id" />-->
        <!--      </a-form-model-item>-->
        <a-form-model-item label="推送标题" prop="title" >
          <a-input v-model="form.title" placeholder="请输入推送标题" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item :label="'推送内容' + warnText" prop="content" >
          <a-textarea v-model="form.content" placeholder="请输入推送内容" :rows="2" :maxLength="50" allow-clear />
        </a-form-model-item>
        <a-form-model-item label="右侧图标" prop="smallIcon" >
          <oss-multi-upload
            v-model="form.smallIcon"
            type="img"
            :maxCount="1"
            :maxSize="0.3"
            bucket="pushNotice"
            :isMultiple="false"
          ></oss-multi-upload>
        </a-form-model-item>
        <a-form-model-item label="大图标" prop="largeIcon" >
          <oss-multi-upload
            v-model="form.largeIcon"
            type="img"
            :maxCount="1"
            :maxSize="0.3"
            bucket="pushNotice"
            :isMultiple="false"
          ></oss-multi-upload>
        </a-form-model-item>
        <a-form-model-item label="推送时间" prop="pushTime" v-if="isShowTime">
          <a-date-picker
            style="width: 100%"
            v-model="form.pushTime"
            @change="onDateChange"
            :showTime="true"
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            allow-clear/>
        </a-form-model-item>
        <!--      <a-form-model-item label="逻辑删除标记 1:删除,0:未删除" prop="isDeleted" v-if="formType === 1">-->
        <!--        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记 1:删除,0:未删除" />-->
        <!--      </a-form-model-item>-->
        <!--      <a-form-model-item label="备注" prop="remark" >-->
        <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
        <!--      </a-form-model-item>-->
        <!--      <a-form-model-item label="版本号" prop="version" v-if="formType === 1">-->
        <!--        <a-input v-model="form.version" placeholder="请输入版本号" />-->
        <!--      </a-form-model-item>-->
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm(0)">
              保存
            </a-button>
            <a-button type="primary" :loading="submitLoading" @click="submitForm(1)" v-if="form.type === 1">
              保存并立即推送
            </a-button>
            <a-button type="primary" :loading="submitLoading" @click="submitForm(2)" v-if="form.type === 1 && form.pushTime">
              保存并定时推送
            </a-button>
            <a-button type="dashed" @click="cancel">
              取消
            </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-drawer>
    <index-script-modal ref="IndexScriptModal" @selectAll="indexScriptAll"/>
    <index-article-modal ref="IndexArticleModal" @selectAll="indexArticleAll"/>
    <shop-list-modal ref="ShopListModal" @selectAll="indexShopAll"/>
    <sheet-list-modal ref="SheetListModal" @selectAll="indexSheetAll"/>
    <index-expo-modal ref="IndexExpoModal" @selectAll="indexExpoAll"/>
  </div>
</template>

<script>
import { getPushNotice, addPushNotice, updatePushNotice, delPushNotice } from '@/api/system/pushNotice'
import Editor from '@/components/Editor'
import { mapGetters } from 'vuex'
import SheetListModal from '@/views/script/sheet/SheetListModal.vue'
import ShopListModal from '@/components/Shop/ShopListModal.vue'
import IndexExpoModal from '@/views/expo/expoScript/modules/indexExpoModal.vue'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import IndexArticleModal from '@/views/community/article/IndexArticleModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssMultiUpload,
    IndexScriptModal,
    IndexArticleModal,
    IndexExpoModal,
    ShopListModal,
    SheetListModal,
    Editor
  },
  data () {
    return {
      submitLoading: false,
      // 是否设置推送时间
      isShowTime: true,
      formTitle: '',
      typeLabels: ['', '请绑定剧本', '请绑定剧评', '请绑定动态', '请绑定讨论', '请绑定种草官', '请绑定剧本集', '请绑定店铺', '请绑定展会'],
      warnText: '',
      caType: null,
      // 表单参数
      form: {
        id: null,
        type: undefined,
        jumpType: undefined,
        relationId: null,
        title: null,
        content: null,
        smallIcon: null,
        largeIcon: null,
        pushTime: null,
        isTimed: null,
        creator: null,
        modifier: null,
        createTime: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null,
        pushWay: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '请选择推送类型', trigger: 'change' }
        ],
        jumpType: [
          { required: true, message: '请选择跳转类型', trigger: 'change' }
        ],
        relationId: [
          { required: true, message: '跳转类型绑定不能为空', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '推送标题不能为空', trigger: 'blur' },
          { max: 40, message: '推送标题不能超过40个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '推送内容不能为空', trigger: 'blur' },
          { max: 50, message: '推送内容不能超过50个字符', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeType(value) {
      if (value === 1) {
        this.form.jumpType = 1
        this.changeJumpType(1)
        this.isShowTime = true
        this.form.pushTime = null
        this.warnText = ''
      } else if (value === 3) {
        this.form.jumpType = 5
        this.changeJumpType(5)
        this.isShowTime = true
        this.form.pushTime = null
        this.warnText = ''
      } else if (value === 4) {
        this.form.jumpType = undefined
        this.isShowTime = false
        this.form.pushTime = null
        this.warnText = ''
      } else if (value === 5) {
        this.form.jumpType = 6
        this.changeJumpType(6)
        this.isShowTime = true
        this.form.pushTime = null
        this.warnText = ''
      } else if (value === 7) {
        this.form.jumpType = undefined
        this.isShowTime = false
        this.warnText = '（推送可指定模板参数，{nickName}代表用户名，{diffDays}代表未登录天数）'
      } else {
        this.form.jumpType = undefined
        this.isShowTime = false
        this.warnText = ''
      }
    },
    changeJumpType (value) {
      this.form.relationId = null
      this.form.remark = this.typeLabels[value]
    },
    jumpFunction () {
      if (this.form.jumpType === 1) {
        this.$refs.IndexScriptModal.open()
      } else if (this.form.jumpType === 2) {
        this.$refs.IndexArticleModal.open(2)
      } else if (this.form.jumpType === 3) {
        this.$refs.IndexArticleModal.open(1)
      } else if (this.form.jumpType === 4) {
        // 讨论未开发完 暂定5
        this.$refs.IndexArticleModal.open(5)
      } else if (this.form.jumpType === 5) {
        // 种草官 -暂时没写
        this.$refs.IndexArticleModal.open()
      } else if (this.form.jumpType === 6) {
        this.$refs.SheetListModal.open()
      } else if (this.form.jumpType === 7) {
        this.$refs.ShopListModal.open()
      } else if (this.form.jumpType === 8) {
        this.$refs.IndexExpoModal.open()
      }
    },
    onDateChange(date, dateString) {
      console.log(date, dateString)
      this.form.pushTime = dateString
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: undefined,
        jumpType: undefined,
        relationId: null,
        title: null,
        content: null,
        smallIcon: null,
        largeIcon: null,
        pushTime: null,
        isTimed: null,
        creator: null,
        modifier: null,
        createTime: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null,
        pushWay: null
      }
    },

    // 1.剧本
    indexScriptAll(row) {
      this.form.relationId = row.id
      console.log('获取到的ids', row.id)
      this.$set(this.form, 'remark', row.name)
      console.log('获取到的scriptName', row.name, '123', this.form)
    },
    // 2.剧评 3.动态 4.讨论
    indexArticleAll(row) {
      this.form.relationId = row.id
      const content = row.content.slice(0, 15) + '...'
      console.log('获取到的ids', row.id)
      this.$set(this.form, 'remark', content)
      console.log('获取到的内容', content, '123', this.form)
    },
    // 6.剧本集
    indexSheetAll(row) {
      this.form.relationId = row.id
      console.log('获取到的ids', row.id)
      this.$set(this.form, 'remark', row.name)
      console.log('获取到的剧本集', row.name, '123', this.form)
    },
    // 7.店铺信息
    indexShopAll(row) {
      this.form.relationId = row.id
      console.log('获取到的ids', row.id)
      this.$set(this.form, 'remark', row.shopName)
      console.log('获取到的店铺', row.shopName, '123', this.form)
    },
    // 7.展会信息
    indexExpoAll(row) {
      this.form.relationId = row.id
      console.log('获取到的ids', row.id)
      this.$set(this.form, 'jumpInfoName', row.name)
      this.$set(this.form, 'remark', row.name)
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPushNotice(id).then(response => {
        this.form = response.data
        if (this.form.type === 1) {
          this.isShowTime = true
        } else if (this.form.type === 3) {
          this.isShowTime = true
        } else if (this.form.type === 4) {
          this.isShowTime = false
        } else if (this.form.type === 5) {
          this.isShowTime = true
        } else if (this.form.type === 7) {
          this.isShowTime = false
        } else {
          this.isShowTime = false
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function (pushWay) {
      const that = this
      this.form.pushWay = pushWay
      if (pushWay === 2) {
        // 如果开启定时推送，则开启标识
        this.form.isTimed = true
      }
      if (pushWay === 1 || pushWay === 2) {
        this.$confirm({
          title: '推送数据警告！',
          content: '请再次确认推送数据是否正确，将推送给全体用户！！！',
          onOk () {
            that.submitPost()
          },
          onCancel () {}
        })
      } else {
        this.submitPost()
      }
    },
    submitPost () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePushNotice(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPushNotice(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
